module.exports = __webpack_public_path__ + "img/LogoYipi_Verde.3df29093.png";